import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import entityApi from "../../service/entityApi";
import { showErrorSnackbar } from "./snackbarSlice";
import handleAsyncThunk from "../handleAsyncThunk";


const createEntityThunk = (typePrefix, entityKey) => {
  return createAsyncThunk(
    `entity/${typePrefix}`,
    async (_, { rejectWithValue, dispatch }) => {
      console.log(`${typePrefix}`);
      try {
        const response = await entityApi.getEntities();
        console.log(`API response for ${entityKey}:`, response);

        if (response.status === 200) {
          const values = Object.values(response?.data?.[entityKey]?.values || {});
          console.log(`Extracted ${entityKey} values:`, values);

          if (values.length === 0) {
            dispatch(showErrorSnackbar({ title: `No ${entityKey} values found in response` }));
            return rejectWithValue(`No ${entityKey} values found`);
          }

          return values;
        } else {
          dispatch(showErrorSnackbar({ title: response?.message || `Failed to fetch ${entityKey}` }));
          return rejectWithValue(response?.message);
        }
      } catch (error) {
        console.error(`Error in ${typePrefix}:`, error);
        dispatch(showErrorSnackbar({ title: error?.message || "Something went wrong" }));
        return rejectWithValue(error.message);
      }
    }
  );
};


export const getCurrencies = createEntityThunk("getCurrencies", "currency ");
export const getStatus = createEntityThunk("getStatus", "status");
export const getPaymentTerms = createEntityThunk("getPaymentTerms", "payment_terms");
export const getDefaultCarrier = createEntityThunk("getDefaultCarrier", "default_carrier");
export const getTaxRule = createEntityThunk("getTaxRule", "tax_rules");

export const getAllEntities = createAsyncThunk(
  "entity/getAllEntities",
  async (_, { rejectWithValue, dispatch }) => {
    try {
        console.log("getAllEntities is being called");
        const response = await entityApi.getEntities();
        console.log("Get all entities response: ", response);
        if (response.status === 200) {
          return response?.data;
        } else {
          const errorMsg = response?.message || `Failed to fetch entities`;
          console.log(errorMsg);
          dispatch(showErrorSnackbar({ title: errorMsg }));
          return rejectWithValue(response?.message);
        }
      } catch (error) {
        console.error(error?.message || "Something went wrong");
        dispatch(showErrorSnackbar({ title: error?.message || "Something went wrong" }));
        return rejectWithValue(error?.message);
      }
  }
)

const entitySlice = createSlice({
  name: "entity",
  initialState: {
    entities: {},
    
    currencies: [],
    status: [],
    paymentTerms: [],
    defaultCarrier: [],
    taxRule: [],
    error: null,
    isLoading: false,
    entitiesLoading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    handleAsyncThunk(builder, getCurrencies, "currencies", "error", "isLoading");
    handleAsyncThunk(builder, getStatus, "status", "error", "isLoading");
    handleAsyncThunk(builder, getPaymentTerms, "paymentTerms", "error", "isLoading");
    handleAsyncThunk(builder, getDefaultCarrier, "defaultCarrier", "error", "isLoading");
    handleAsyncThunk(builder, getTaxRule, "taxRule", "error", "isLoading");
    
    handleAsyncThunk(builder, getAllEntities, "entities", "error", "entitiesLoading");
  },
});

export default entitySlice.reducer;
